import React from "react";
import Box from "@vapor/react-material/Box";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { useForm, Controller } from "react-hook-form";
import MenuItem from "@vapor/react-material/MenuItem";
import Select from "@vapor/react-material/Select";
import Button from "@vapor/react-material/Button";
import Stack from "@vapor/react-material/Stack";

interface FormData {
  languageSelect: string;
  formatSelect: string;
}

interface LanguageAndFormatFormProps {
  language: string;
  format: string;
  handleClose: () => void;
}

export const LanguageAndFormatForm: React.FC<LanguageAndFormatFormProps> = ({
  handleClose,
  language,
  format
}) => {
  const { handleSubmit, control } = useForm<FormData>();
  const onSubmit = (data: FormData) => console.log(data);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box
        sx={{
          marginLeft: 2.4,
          marginTop: 1.5,
          display: "flex",
          flexDirection: "column"
        }}
      >
        <ExtendedTypography
          sx={{ margin: 1 }}
          color="primary.interactiveDefault"
          variant="titleSmall"
        >
          Lingua e localizzazione
        </ExtendedTypography>
        <ExtendedTypography variant="bodyLarge700" sx={{ margin: 1 }}>
          Lingua
        </ExtendedTypography>
        <ExtendedTypography
          color="primary.textDisabledColor"
          variant="body"
          sx={{ margin: 1 }}
        >
          Imposta la lingua in cui vuoi utilizzare il software
        </ExtendedTypography>
        <Controller
          name="languageSelect"
          control={control}
          defaultValue={language}
          rules={{ required: "Please select an option" }}
          render={({ field }) => (
            <Select sx={{ width: 200, margin: 1 }} {...field}>
              <MenuItem value="Italiano">Italiano</MenuItem>
              <MenuItem value="English">English</MenuItem>
              <MenuItem value="Spanish">Spanish</MenuItem>
            </Select>
          )}
        />
        <ExtendedTypography variant="bodyLarge700" sx={{ margin: 1 }}>
          Formato della regione
        </ExtendedTypography>
        <ExtendedTypography
          color="primary.textDisabledColor"
          variant="body"
          sx={{ margin: 1 }}
        >
          Scegli come visualizzare formati di data, ora e numeri in base alla
          lingua impostata.
        </ExtendedTypography>
        <Controller
          name="formatSelect"
          control={control}
          defaultValue={format}
          rules={{ required: "Please select an option" }}
          render={({ field }) => (
            <Select sx={{ width: 200, margin: 1 }} {...field}>
              <MenuItem value="it-IT(Italia)">it-IT(Italia)</MenuItem>
              <MenuItem value="en-EN(English)">en-EN(English)</MenuItem>
              <MenuItem value="sp-SP(Spanish)">sp-SP(Spanish)</MenuItem>
            </Select>
          )}
        />
        <ExtendedTypography
          color="primary.textDisabledColor"
          variant="body"
          sx={{ margin: 1 }}
        >
          Anteprima: la data oggi e 16/06/2021, anche scritta come Mercoledi 16
          giugno 2021. L'orario e visualizzato come 12:30. Il formato dei numeri
          e 1000.00.
        </ExtendedTypography>
        <Box
          sx={{
            display: "flex",
            height: "100%",
            alignItems: "end",
            justifyContent: "end"
          }}
        >
          <Stack direction="row" sx={{ p: 1, mt: 25 }}>
            <Button variant="outlined" onClick={handleClose}>
              Anulla
            </Button>
            <Button variant="contained" sx={{ ml: 1 }} type="submit">
              Conferma
            </Button>
          </Stack>
        </Box>
      </Box>
    </form>
  );
};
